angular.module("app").filter("translateColumn", ['$filter', function ($filter) {
    var translatableColumns = {
        "blocks": {
        },
        default: {
        },
        "popups": {
            "show_on_page": 'popups.showOnPage.'
        }
    };
    
    return function (value, cellName, isBlock, tableName) {
        var groupKey = isBlock? "blocks": (tableName && translatableColumns[tableName])?tableName: 'default';
        if (translatableColumns[groupKey][cellName] !== undefined){
            return $filter("translate")(translatableColumns[groupKey][cellName] + value);
        }
        return value;
    }

}]);
